var isSameDay = function isSameDay(date1, date2) {
  var d1 = new Date(date1);
  var d2 = new Date(date2);
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
};

var isAfter = function isAfter(date1, date2) {
  return Boolean(date1) && new Date(date1).getTime() > new Date(date2).getTime();
};

module.exports = {
  isSameDay: isSameDay,
  isAfter: isAfter
};